import { initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA4AFXGsi6R3omCqOVeI3mY8RzbieHs_KE",
  authDomain: "academy-analytics-10afd.firebaseapp.com",
  projectId: "academy-analytics-10afd",
  storageBucket: "academy-analytics-10afd.firebasestorage.app",
  messagingSenderId: "448863251542",
  appId: "1:448863251542:web:46f71316ac15c0df009ff7",
  measurementId: "G-0GFQ8B84WL"
};

const app = initializeApp(firebaseConfig);

// App Check
initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider("6Lfp7T0tAAAAAGVnkWEskQyBqqw4ydDE6aWz7bss"),
  isTokenAutoRefreshEnabled: true,
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);